import type { Coordinate } from '@/types/properties';
import type { DynamicComponentProps } from '@/types/commontypes';
import * as React from 'react';
import { InputBox } from '../shape.map';
import styles from '../../../styles/global.module.css';

const CoordinateComponent: React.FC<DynamicComponentProps<Coordinate[]>> = ({ type, value, onChange }) => {
  // Ensure value is an array of arrays (i.e., [x, y] coordinate pairs)
  const ensureValueStructure = (): Coordinate[] => {
    if (!Array.isArray(value)) return [];

    return value.map(item =>
      Array.isArray(item) && item.length === 2 && typeof item[0] === 'number' && typeof item[1] === 'number'
        ? ([item[0], item[1]] as Coordinate)
        : [0, 0],
    );
  };

  const updatedValue: Coordinate[] = ensureValueStructure();

  const handleXChange = (index: number, xValue: string | number) => {
    const newX = typeof xValue === 'string' ? parseFloat(xValue) : xValue;
    if (!isNaN(newX)) {
      const newValue: Coordinate[] = [...updatedValue];
      while (newValue.length <= index) {
        newValue.push([0, 0]);
      }
      newValue[index][0] = newX;
      onChange(newValue);
    }
  };

  const handleYChange = (index: number, yValue: string | number) => {
    const newY = typeof yValue === 'string' ? parseFloat(yValue) : yValue;
    if (!isNaN(newY)) {
      const newValue: Coordinate[] = [...updatedValue];
      while (newValue.length <= index) {
        newValue.push([0, 0]);
      }
      newValue[index][1] = newY;
      onChange(newValue);
    }
  };

  const getCoordinateCount = () => {
    if (type === 'FibChannel') return 3;
    if (type === 'ElliottImpulse12345') return 6;
    return 2;
  };

  const coordinateCount = getCoordinateCount();

  return (
    <div className={`${styles.coordinate_wrapper} flex flex-col gap-4`}>
      {Array.from({ length: coordinateCount }).map((_, index) => (
        <div key={index} className="flex items-center gap-2">
          <label className="nowrap">#{index + 1} (bar, price)</label>
          <InputBox
            type="number"
            value={updatedValue[index]?.[0] ?? ''}
            onChange={xValue => handleXChange(index, xValue)}
          />
          <InputBox
            type="number"
            value={updatedValue[index]?.[1] ?? ''}
            onChange={yValue => handleYChange(index, yValue)}
          />
        </div>
      ))}
    </div>
  );
};

export default CoordinateComponent;
